/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { later } from '@ember/runloop';
import { isiOS } from '@linc-technologies/linced-common/utils/platform';

export default class CfStreamVideo extends Component {
  media = null;
  @tracked
  isiOS = false;

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    if (!this.media.video.streamProcessed) {
      later(this, 'updateMedia', 15000);
    }
    this.isiOS = isiOS();
  }

  updateMedia() {
    this.media.reload();
  }
}
